/**
 * Segment event names: bulk content converter (BulkConvertDrawer) and move-to-district.
 */

export const BULK_CONVERTER_SEGMENT = {
  CREATE_DOCUMENT_CLICK: 'BulkConverter:CreateDocumentClick',
  /** User closed the drawer (drawer X, Pear UI close, or error Cancel). Overlay/Escape disabled. */
  PDL_DRAWER_CLOSE: 'BulkConverter:PDLDrawerClose',
  CONVERT_UPLOAD_COMPLETE: 'BulkConverter:ConvertUploadComplete',
  /** My Content (test list) grade/subject filter — mirrors Pear usage-events naming. */
  MY_CONTENT_FILTER_SELECTED: 'BulkConverter:MyTests:FilterSelected',
  MY_CONTENT_BULK_CONVERSION_CSV_DOWNLOAD:
    'BulkConverter:MyTests:ClickBulkConversionCsvDownload',
  MOVE_TO_DISTRICT_CONFIRM: 'BulkMoveToDistrict:ConfirmClick',
  MOVE_TO_DISTRICT_CANCEL: 'BulkMoveToDistrict:ModalCancel',
  MOVE_TO_DISTRICT_API_RESULT: 'BulkMoveToDistrict:ApiResult',
  MOVE_TO_DISTRICT_SELECT_ALL: 'BulkMoveToDistrict:SelectAll',
  MOVE_TO_DISTRICT_DESELECT_ALL: 'BulkMoveToDistrict:DeselectAll',
}
